import profileService from '@/services/api/profile/profileService';

export default {
  async getUserProfile({ commit }, idToken) {
    const { userProfile } = await profileService.getProfileData('userProfile', idToken);
    if (idToken) commit('auth/setTempUser', userProfile);
    else commit('auth/setUser', userProfile);
  }
};
